module.exports = __webpack_public_path__ + "media/images/credit_cards_default-ca40fcfb828429c1f19b973bda3ba122.png";